export enum EventMessageType {
  BATCH_COUNTER = 'batch-counter',
  DAMAGE_REPORTS_COUNTER_EVENT = 'damage-reports-counter-event',
  REJECTED_TYRE_COUNTER_EVENT = 'rejected-tyre-counter-event',
  DOUBLE_SN_TYRE_COUNTER_EVENT = 'double-sn-tyre-counter-event',
  BATCH_UPDATED_EVENT = 'batch-updated',
  UPDATED_TYRE_EVENT = 'tyre-updated',
  DATA_STREAM = 'data-stream',
  DATA_STREAM_NOTICE = 'data-stream-notice',
  DATA_STREAM_PROGRESS = 'data-stream-progress',
  NEW_NOTIFICATION = 'new-notification-event',
  SSO_LOGOUT_EVENT = 'sso-logout-event',
}
